import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./FinanceV2.css";

const SECTIONS = [
  {
    label: "Home",
    items: [
      { to: "/finance-v2/dashboard", label: "Overview", icon: "bi-grid-1x2" },
      { to: "/finance-v2/import", label: "Import & sync", icon: "bi-cloud-download" },
      { to: "/finance-v2/guides", label: "Guides", icon: "bi-book" },
    ],
  },
  {
    label: "Setup",
    items: [
      { to: "/finance-v2/setup", label: "Setup wizard", icon: "bi-gear" },
      { to: "/finance-v2/chart-of-accounts", label: "Chart of accounts", icon: "bi-diagram-3" },
      { to: "/finance-v2/mappings", label: "Mappings & vendors", icon: "bi-link-45deg" },
    ],
  },
  {
    label: "Transactions",
    items: [
      { to: "/finance-v2/transactions", label: "Enter transactions", icon: "bi-pencil-square" },
      { to: "/finance-v2/journals", label: "Journals", icon: "bi-journal-text" },
    ],
  },
  {
    label: "Reports",
    items: [
      { to: "/finance-v2/reports", label: "Financial reports", icon: "bi-bar-chart-line" },
      { to: "/finance-v2/general-ledger", label: "General ledger", icon: "bi-list-columns" },
      { to: "/finance-v2/receivables", label: "Receivables", icon: "bi-people" },
      { to: "/finance-v2/bank-reconcile", label: "Bank reconcile", icon: "bi-bank" },
    ],
  },
  {
    label: "Admin",
    items: [
      { to: "/finance-v2/fiscal-periods", label: "Close period", icon: "bi-calendar-check" },
      { to: "/finance-v2/audit-log", label: "Audit log", icon: "bi-shield-check" },
    ],
  },
];

export default function FinanceV2ModuleNav() {
  const location = useLocation();

  return (
    <nav className="fv2-module-nav mb-3" aria-label="Finance V2 navigation">
      {SECTIONS.map((section) => {
        const sectionActive = section.items.some((item) => location.pathname === item.to);
        return (
          <div key={section.label} className={`fv2-module-nav-section ${sectionActive ? "is-active" : ""}`}>
            <div className="fv2-module-nav-label">{section.label}</div>
            <div className="fv2-module-nav-items">
              {section.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) => `fv2-module-nav-link ${isActive ? "active" : ""}`}
                  title={item.label}
                >
                  <i className={`bi ${item.icon}`} />
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </div>
          </div>
        );
      })}
    </nav>
  );
}
